import { useEffect } from "react";

const DEFAULT_TITLE = "CloudService.hr — AI & Business Automation Studio";
const DEFAULT_DESC =
  "CloudService baut digitale Produkte: AI-Systeme, SaaS-Plattformen, Mobile Apps und Business Automation. Echte Projekte, live im Einsatz.";
const SITE_ORIGIN = "https://cloudservice.hr";

// Per-route SEO: sets document title + meta description, restores defaults on unmount.
export function useSEO(title, description) {
  useEffect(() => {
    document.title = title || DEFAULT_TITLE;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    const prev = meta.getAttribute("content");
    meta.setAttribute("content", description || DEFAULT_DESC);

    const setOg = (prop, value) => {
      let el = document.querySelector(`meta[property="${prop}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("property", prop);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };
    setOg("og:title", title || DEFAULT_TITLE);
    setOg("og:description", description || DEFAULT_DESC);

    // Canonical + og:url follow the current route (production domain)
    const canonicalUrl = `${SITE_ORIGIN}${window.location.pathname === "/" ? "/" : window.location.pathname}`;
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    const prevCanonical = canonical.getAttribute("href");
    canonical.setAttribute("href", canonicalUrl);
    setOg("og:url", canonicalUrl);

    return () => {
      document.title = DEFAULT_TITLE;
      if (meta) meta.setAttribute("content", prev || DEFAULT_DESC);
      setOg("og:title", DEFAULT_TITLE);
      setOg("og:description", DEFAULT_DESC);
      if (canonical) canonical.setAttribute("href", prevCanonical || `${SITE_ORIGIN}/`);
      setOg("og:url", prevCanonical || `${SITE_ORIGIN}/`);
    };
  }, [title, description]);
}
